import axios from 'axios';
import { getHeaders } from './authService';
import store from "../store";
import { getFlavourBaseAPIURL } from '@/flavors';
import verFlavor from "@/appFlavorAndVersion";

let loggingOut = false;

// A 401 from a secure endpoint means the session is no longer valid
// (token expired or revoked), so clear it and send the user back to login.
// Guarded so a burst of parallel failing calls only logs out once.
export function handleAuthError(err) {
  if (err?.response?.status !== 401) return;
  if (loggingOut || !localStorage.getItem('accessToken')) return;
  loggingOut = true;

  store.commit('loading', false);
  Promise.resolve(store.dispatch('logout'))
    .then(() => {
      store.commit('updateUserLoggedIn');
      store.commit('clearLogoutSessionVal');
      return import('@/router');
    })
    .then(({ default: router }) => router.push('/'))
    .catch(() => { window.location.href = '/'; })
    .finally(() => { loggingOut = false; });
}

export async function securePostAPI(data, path, showLoading = true) {
  

  store.commit('loading', showLoading)
  return axios.post(store.getters.apiBaseUrl + path, data, {
    headers: getHeaders()
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    handleAuthError(err);
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

// creating a PUT apiService to handle PUT feedback request.
export async function securePutAPI(data, path, showLoading = true) {
  console.log("securePutAPI", data, path,store.getters.apiBaseUrl);
  

  store.commit('loading', showLoading)
  return axios.put(store.getters.apiBaseUrl + path, data, {
    headers: getHeaders()
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    handleAuthError(err);
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

const PROCTOR_BASE = 'mysa/proctor/';

// Silent (no loading-overlay) calls used during an in-progress test attempt,
// so background media uploads and violation logging never block the exam UI.
export async function proctoringUploadUrlAPI(data) {
  return securePostAPIWithoutOverlay(data, `${PROCTOR_BASE}upload-url`);
}

export async function proctoringSaveViolationsAPI(data) {
  return securePostAPIWithoutOverlay(data, `${PROCTOR_BASE}save-violations`);
}

export async function securePostAPIWithoutOverlay(data, path) {

  return axios.post(store.getters.apiBaseUrl + path, data, {
    headers: getHeaders()
  }).then(res => {
    return res.data
  }).catch(err => {
    handleAuthError(err);
    console.log(err);
    return { error: `${err.code} | ${err.message}`, data: err.response?.data }
  });
}

export async function securePostAPIWithoutHeadersWithoutOverlay(data, path) {
  return axios.post(store.getters.apiBaseUrl + path, data).then(res => {
    return res.data
  }).catch(err => {
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function securePutAPIWithoutOverlay(data, path, headers) {
  const header = {...getHeaders() , ...headers};
  return axios.put(store.getters.apiBaseUrl + path, data, {
    headers:  header
  }).then(res => {
    return res.data
  }).catch(err => {
    handleAuthError(err);
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function secureGetAPI(data, path, loadingRequired = true) {
  loadingRequired ? store.commit('loading', true) : ''
  return axios.get(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    handleAuthError(err);
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function secureDeleteAPI(data, path) {
  store.commit('loading', true)
  return axios.delete(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    handleAuthError(err);
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function secureGetAPIWithCredentials(data, path) {
  /*store.commit('loading', true)
  return axios.get(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
    withCredentials: true,
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });*/
  fetch(store.getters.apiBaseUrl + path, {
    credentials: 'include',
    headers: getHeaders()
  })
    .then(async response => {
      const data = await response.json();

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response statusText
        const error = (data && data.message) || response.statusText;
        console.log(JSON.stringify(error));
        return Promise.reject(error);
      }

      return data;
    })
    .catch(error => {
      this.errorMessage = error;
      console.log("There was an error!", error);
    });
}


export async function secureGetAPIWithoutOverlay(data, path) {
  return axios.get(store.getters.apiBaseUrl + path, {
    headers: getHeaders(),
  }).then(res => {
    return res.data
  }).catch(err => {
    handleAuthError(err);
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

// special function to be called initially once to retrieve api urls and other properties from server.]
export async function fetchAPIUrls() {
  store.commit('loading', true)
  let req = { appFlavour: verFlavor.APP_FLAVOR, versionNumber: verFlavor.APP_VERSION }
  return axios.post(getFlavourBaseAPIURL() + 'mysa/api/url', req, {
    headers: getHeaders(),
  }).then(res => {
    store.commit('loading', false)
    return res.data
  }).catch(err => {
    store.commit('loading', false)
    console.log(err);
    return { error: `${err.code} | ${err.message}` }
  });
}

export async function referralAPI(rollNumber) {
  const BASE_URL = store.getters.apiBaseUrl
  return axios.get(`${BASE_URL}mysa/referral-data?rollNumber=${rollNumber}`).then(res => res.data)
  .catch(err => {
    console.log('Error fetching referral details', err)
  })
}

function selfTestHeaders() {
  const { userid, deviceid, domainid, organizationid, token } = getHeaders();
  return { userId: userid, deviceId: deviceid, domainId: domainid ?? '', organizationId: organizationid, token };
}

export async function selfTestGetAPI(path, showLoading = true) {
  if (showLoading) store.commit('loading', true);
  return axios.get(store.getters.apiBaseUrl + path, { headers: selfTestHeaders() }).then(res => {
    store.commit('loading', false);
    return res.data;
  }).catch(err => {
    store.commit('loading', false);
    console.log(err);
    return { error: `${err.code} | ${err.message}` };
  });
}

export async function selfTestPostAPI(path, data, showLoading = true) {
  if (showLoading) store.commit('loading', true);
  return axios.post(store.getters.apiBaseUrl + path, data, { headers: selfTestHeaders() }).then(res => {
    store.commit('loading', false);
    return res.data;
  }).catch(err => {
    store.commit('loading', false);
    console.log(err);
    return { error: `${err.code} | ${err.message}` };
  });
}

// Vidya Assist AI ChatBot
const ORGANIZATION_ID = "1";
const VeevaBASE_URL = "https://vidyassist.vidyamandir.com";

export async function sendChatMessage(deviceId, userId, message, file = null, conversationId = null) {
  try {
    const access_Token = localStorage.getItem("accessToken");

    const formDataJwt = new FormData();
    formDataJwt.append("userId", userId);
    formDataJwt.append("deviceId", deviceId);
    formDataJwt.append("organizationId", ORGANIZATION_ID);

    const jwtRes = await axios.post(`${VeevaBASE_URL}/session`, formDataJwt, {
      headers: {
        Authorization: `Bearer ${access_Token}`,
        "Content-Type": "multipart/form-data"
      }
    });

    const JWT = jwtRes.data.access_token;
    if (!JWT) throw new Error("Failed to get internal JWT");

    const formData = new FormData();
    formData.append("selected_model", "gpt-5-mini-2025-08-07");
    formData.append("message", message);
    if(conversationId) {
      formData.append("conversation_id", conversationId);
    }
    if (file) {
      formData.append("file", file);
    }

    const chatRes = await axios.post(`${VeevaBASE_URL}/chat/`, formData, {
      headers: {
        "Authorization": `Bearer ${JWT}`,
        "Content-Type": "multipart/form-data"
      }
    });

    return chatRes.data;
  } catch (error) {
    console.error("Chat API Error:", error.response?.data || error.message);
    return { message: "Error contacting server." };
  }
}

// Vidya Assist AI ChatBot -- Streaming Chat (SSE)
export async function sendStreamChatMessage(
  deviceId,
  userId,
  message,
  file = null,
  conversationId = null,
  { onChunk, onDone, onError, signal } = {}
) {
  try {
    const access_Token = localStorage.getItem("accessToken");

    const formDataJwt = new FormData();
    formDataJwt.append("userId", userId);
    formDataJwt.append("deviceId", deviceId);
    formDataJwt.append("organizationId", ORGANIZATION_ID);

    const jwtRes = await axios.post(`${VeevaBASE_URL}/session`, formDataJwt, {
      headers: {
        Authorization: `Bearer ${access_Token}`,
        "Content-Type": "multipart/form-data"
      }
    });

    const JWT = jwtRes.data.access_token;
    if (!JWT) throw new Error("Failed to get internal JWT");

    const formData = new FormData();
    formData.append("selected_model", "gpt-5.2-2025-12-11");
    formData.append("message", message);
    if (conversationId) {
      formData.append("conversation_id", conversationId);
    }
    if (file) {
      formData.append("file", file);
    }

    const response = await fetch(`${VeevaBASE_URL}/chat/stream`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${JWT}`,
        Accept: "text/event-stream"
      },
      body: formData,
      signal
    });

    if (!response.ok || !response.body) {
      throw new Error(`Stream request failed: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    const result = { message: "", conversation_id: conversationId || null };

    // Extract a usable text delta from an SSE data payload.
    // Supports raw text, JSON deltas like { content }, { message }, { text },
    // { delta: { content } }, and OpenAI-style { choices: [{ delta: { content } }] }.
    const extractDelta = (data) => {
      try {
        const parsed = JSON.parse(data);
        if (typeof parsed === "string") return { text: parsed, payload: null };
        const payload = parsed;
        const text =
          payload.content ??
          payload.message ??
          payload.text ??
          payload.delta?.content ??
          payload.choices?.[0]?.delta?.content ??
          "";
        if (payload.conversation_id) {
          result.conversation_id = payload.conversation_id;
        }
        return { text: typeof text === "string" ? text : "", payload };
      } catch {
        return { text: data, payload: null };
      }
    };

    const processEvent = (rawEvent) => {
      const dataLines = rawEvent
        .split("\n")
        .filter((line) => line.startsWith("data:"))
        .map((line) => line.slice(5).trimStart());
      if (dataLines.length === 0) return;
      const data = dataLines.join("\n");
      if (data === "[DONE]") return;
      const { text } = extractDelta(data);
      if (text) {
        result.message += text;
        if (typeof onChunk === "function") onChunk(text, result);
      }
    };

    let streaming = true;
    while (streaming) {
      const { value, done } = await reader.read();
      if (done) {
        streaming = false;
        break;
      }
      buffer += decoder.decode(value, { stream: true });
      let boundary;
      while ((boundary = buffer.indexOf("\n\n")) !== -1) {
        const rawEvent = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        processEvent(rawEvent);
      }
    }
    // Flush any trailing event without a terminating blank line.
    if (buffer.trim().length > 0) {
      processEvent(buffer);
    }

    if (typeof onDone === "function") onDone(result);
    return result;
  } catch (error) {
    console.error("Stream Chat API Error:", error?.message || error);
    if (typeof onError === "function") onError(error);
    return { message: "Error contacting server.", conversation_id: conversationId || null };
  }
}

// Vidya Assist AI -- Streaming Simplify Solution (SSE)
export async function simplifySolutionStream(
  explanation,
  { onChunk, onDone, onError, signal } = {}
) {
  try {
    const response = await fetch(`${VeevaBASE_URL}/simplify-solution/stream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream"
      },
      body: JSON.stringify({ explanation }),
      signal
    });

    if (!response.ok || !response.body) {
      throw new Error(`Stream request failed: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    const result = { message: "" };

    const extractDelta = (data) => {
      try {
        const parsed = JSON.parse(data);
        if (typeof parsed === "string") return parsed;
        return (
          parsed.simplified_explanation ??
          parsed.explanation ??
          parsed.content ??
          parsed.message ??
          parsed.text ??
          parsed.delta?.content ??
          parsed.choices?.[0]?.delta?.content ??
          ""
        );
      } catch {
        return data;
      }
    };

    const processEvent = (rawEvent) => {
      const dataLines = rawEvent
        .split("\n")
        .filter((line) => line.startsWith("data:"))
        .map((line) => line.slice(5).trimStart());
      if (dataLines.length === 0) return;
      const data = dataLines.join("\n");
      if (data === "[DONE]") return;
      const text = extractDelta(data);
      if (typeof text === "string" && text) {
        result.message += text;
        if (typeof onChunk === "function") onChunk(text, result);
      }
    };

    let streaming = true;
    while (streaming) {
      const { value, done } = await reader.read();
      if (done) {
        streaming = false;
        break;
      }
      buffer += decoder.decode(value, { stream: true });
      let boundary;
      while ((boundary = buffer.indexOf("\n\n")) !== -1) {
        const rawEvent = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        processEvent(rawEvent);
      }
    }
    if (buffer.trim().length > 0) {
      processEvent(buffer);
    }

    if (typeof onDone === "function") onDone(result);
    return result;
  } catch (error) {
    console.error("Simplify Solution Stream Error:", error?.message || error);
    if (typeof onError === "function") onError(error);
    return { message: "" };
  }
}

// Vidya Assist AI ChatBot -- Get Previous Chats
export async function getPreviousChats(deviceId, userId, organizationId) {
  try {
    const access_Token = localStorage.getItem("accessToken");

    const formDataJwt = new FormData();
    formDataJwt.append("userId", userId);
    formDataJwt.append("deviceId", deviceId);
    formDataJwt.append("organizationId", organizationId);

    const jwtRes = await axios.post(`${VeevaBASE_URL}/session`, formDataJwt, {
      headers: {
        Authorization: `Bearer ${access_Token}`,
        "Content-Type": "multipart/form-data"
      }
    });

    const JWT = jwtRes.data.access_token;
    if (!JWT) throw new Error("Failed to get internal JWT");

    const response = await axios.get(`${VeevaBASE_URL}/conversations`, {
      headers: {
        "Authorization": `Bearer ${JWT}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Get Previous Chats Error:", error.response?.data || error.message);
    return { conversations: [] };
  }
}

// Vidya Assist AI ChatBot -- Fetch Single Conversation
export async function fetchVeevaConversation(deviceId, userId, organizationId, conversationId) {
  try {
    const access_Token = localStorage.getItem("accessToken");

    const formDataJwt = new FormData();
    formDataJwt.append("userId", userId);
    formDataJwt.append("deviceId", deviceId);
    formDataJwt.append("organizationId", organizationId);

    const jwtRes = await axios.post(`${VeevaBASE_URL}/session`, formDataJwt, {
      headers: {
        Authorization: `Bearer ${access_Token}`,
        "Content-Type": "multipart/form-data"
      }
    });

    const JWT = jwtRes.data.access_token;
    if (!JWT) throw new Error("Failed to get internal JWT");

    const response = await axios.get(`${VeevaBASE_URL}/conversations/${conversationId}`, {
      headers: {
        "Authorization": `Bearer ${JWT}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Fetch Conversation Error:", error.response?.data || error.message);
    return null;
  }
}

// Vidya Assist AI ChatBot -- Clearing Session
export async function clearSession(conversationId, userId) {
  try {
    const access_Token = localStorage.getItem("accessToken");

    const formDataJwt = new FormData();
    formDataJwt.append("userId", userId);

    const jwtRes = await axios.post(`${VeevaBASE_URL}/session`, formDataJwt, {
      headers: {
        Authorization: `Bearer ${access_Token}`,
        "Content-Type": "multipart/form-data"
      }
    });

    const JWT = jwtRes.data.access_token;
    if (!JWT) throw new Error("Failed to get internal JWT");

    const formData = new FormData();
    formData.append("conversation_id", conversationId);

    const response = await axios.post("https://vidyassist.vidyamandir.com/clear_session/", formData, {
      headers: { "Content-Type": "multipart/form-data", "Authorization": `Bearer ${JWT}`, }
    });

    return response.data; // Expected: some confirmation
  } catch (error) {
    console.error("Clear Session Error:", error);
    return { message: "Failed to clear session." };
  }
}

